import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import contactView from '../views/contactView.vue'
import hireView from '../views/hireView.vue'
import newsDetail from '../views/newsDetail.vue'
import newsView from '../views/newsView.vue'
import productDetail from '../views/productDetail.vue'
import productView from '../views/productView.vue'
import mySetting from '../views/setting.vue'
import requestInfo from '../views/requestInfo.vue'
import supportView from '../views/supportView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutView
  },
  {
    path: '/product',
    name: 'product',
    // meta: {
    //   keepAlive: true //该路由会被缓存
    // },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: productView
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: productDetail
  },
  {
    path: '/setting',
    name: 'setting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: mySetting
  },
  {
    path: '/requestInfo',
    name: 'requestInfo',
    // meta: {
    //   keepAlive: true //该路由会被缓存
    // },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: requestInfo
  },
  {
    path: '/support',
    name: 'support',
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: supportView
  },
  {
    path: '/news',
    name: 'news',
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: newsView
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: newsDetail
  },
  {
    path: '/contact',
    name: 'contact',
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: contactView
  },
  {
    path: '/hire',
    name: 'hire',
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: hireView
  }
]

// const router = new VueRouter({
//   routes
// })
const router = new VueRouter({
  mode:'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 } //期望滚动到哪个的位置
    }
   },
})

export default router
